<template>
  <header class="pos-header bg-white">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-xl-4 col-lg-4 col-md-6">
          <div class="greeting-text">
            <div class="card-title mb-0">
              <router-link to="" @click.native="onRefreshPos" >
                <img :src="logoBrink"  class="pos-logo" alt="logo" title="Da clic para refrescar información"/>
              </router-link>
            </div>
            <h3 class="card-label mb-0 font-weight-bold text-primary-brink-darkpurple">
              {{location}}
              <h5 class="card-label mb-0 text-muted">{{ name }}</h5>
            </h3>
          </div>
        </div>
        <div class="col-xl-4 col-lg-5 col-md-6 clock-main">
          <nav-clock />
        </div>
        <div class="col-xl-4 col-lg-3 col-md-12 order-lg-last order-second">
          <div class="topbar justify-content-end">

            <button class="btn btn-primary-brink-orange-darkpurple px-3 py-2 mr-3" title="Corte de Caja" @click.stop="openPettyCash">
              <i class="fas fa-cash-register mr-2"></i>
              Corte caja
            </button>

            

            <b-dropdown
              variant="link"
              right
              class="topbar-item"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <div
                  class="
                    btn btn-icon
                    w-auto
                    h-auto
                    btn-clean
                    d-flex
                    align-items-center
                    py-0
                  "
                >
                  <span class="symbol symbol-35 symbol-light-success">
                    <span class="symbol-label font-size-h5">
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 16 16"
                        class="bi bi-person-fill"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                        ></path>
                      </svg>
                    </span>
                  </span>
                </div>
              </template>
              <!--
              <b-dropdown-item @click="goToProfile">
                <template>
                  <span class="svg-icon svg-icon-xl svg-icon-primary mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      height="20px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-user"
                    >
                      <path
                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                      ></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </span>
                  Mi perfil
                </template>
              </b-dropdown-item>
              -->
              <b-dropdown-item @click="openAddStock">
                <template>
                  <span class="svg-icon svg-icon-xl svg-icon-primary mr-2">
                    <i class="fas fa-store mr-2"></i>
                  </span>
                  Agregar Inventario
                </template>
              </b-dropdown-item>

              <b-dropdown-item @click="openRegisterExpense">
                <template>
                  <span class="svg-icon svg-icon-xl svg-icon-primary mr-2">
                    <i class="fas fa-money-bill mr-2"></i>
                  </span>
                  Registrar Gasto
                </template>
              </b-dropdown-item>

              <b-dropdown-item @click="logout">
                <template>
                  <span class="svg-icon svg-icon-xl svg-icon-primary mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      height="20px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-power"
                    >
                      <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                      <line x1="12" y1="2" x2="12" y2="12"></line>
                    </svg>
                  </span>
                  Cerrar sesión
                </template>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

				<!-- Modal para corte de caja -->
				<div>
					<b-modal ref="modal-petty-cash" size="lg" 
						:hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
            <h2 class="text-center">Corte de caja</h2>
						<hr class="my-3">
						<div class="modal-body">
							<form id="formCashOut">							
								<div class="form-group row card card-custom gutter-b bg-white">
                  <b-table
                    :items="cashOutInfo"
                    :fields="cashOutInfoFields"
                    responsive
                  >
                  </b-table>
								</div>
								<div class="form-group row">
									<div class="col-md-6">
                    <b-table
                      :items="incidentsInfo"
                      :fields="incidentsInfoFields"
                      responsive
                      head-variant="dark"
                    >
                    </b-table>
									</div>
									<div class="col-md-6">
                    <b-table
                      :items="expensesInfo"
                      :fields="expensesOutInfoFields"
                      responsive
                      head-variant="dark"
                    >
                    </b-table>
									</div>
								</div>
								<div class="form-group row">
                  <!--
									<div class="col-md-3">
                    <h4>Caja chica</h4>
										<fieldset class="form-group mb-3">
                      <h2 class="border-0 d-flex text-primary-brink-darkpurple font-size-h4">${{amountPettyCash}}</h2>
										</fieldset>
									</div>
                  -->
									<div class="col-md-3">
                    <h4>Caja Chica</h4>
                      <input type="number" class="form-control form-control-high" name="inputAmountPettyCash" id="inputAmountPettyCash" min="1" v-model="amountPettyCash"
                             v-on:keypress="NumbersOnly">
									</div>
									<div class="col-md-3">
										<h4 style="color: green">Venta total del día</h4>
										<fieldset class="form-group mb-3">
											  <h2 class="border-0 d-flex text-primary-brink-darkpurple font-size-h4">${{fixedFormat(amountCashOutCalculated)}}</h2>
										</fieldset>
									</div>
									<div class="col-md-3">
										<h4>Venta con Tarjeta</h4>
										<fieldset class="form-group mb-3">
											  <h2 class="border-0 d-flex text-primary-brink-darkpurple font-size-h4">${{amountCardPayments}}</h2>
										</fieldset>
									</div>
									<div class="col-md-3">
                    <h4>Total en Efectivo</h4>
                      <fieldset class="form-group mb-3">
                          <h2 class="border-0 d-flex text-primary-brink-darkpurple font-size-h4">${{fixedFormat(amountTotalEfectivo,2)}}</h2>
                      </fieldset>
                      <!--
                      <input type="number" class="form-control form-control-high" name="inputAmountExist" id="inputAmountExist" min="1" v-model="amountExist"
                             v-on:keypress="NumbersOnly">
                      -->
									</div>
								</div>
							</form>
						</div>
						<template #modal-footer>
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cashOutCancel">
							Cancelar
						</b-button>
						<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.stop="cashOutRegister">
							Registrar corte de caja
						</b-button>
						</template>
					</b-modal>
				</div>


				<!-- Modal para agregar inventario -->
				<div>
					<b-modal ref="modal-add-stock" :hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
            <h2 class="text-center">Agregar inventario</h2>
						<hr class="my-3">
						<div>
							<div class="row align-items-center mt-2">
								<b-form-select 
									v-model="productToAddStockSelected"
									:options="productsToAddStock"
									class="m-2"
									value-field="product_id"
									text-field="product_name"
									@change="onChangeProductToAddStock">
								</b-form-select>
							</div>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Producto seleccionado:</h5>
								<h5>{{ productToAddStockName }}</h5>
							</div>
						</div>
            <div>
              <div class="row align-items-center mt-2">
                <div class="col-lg-7 col-6 text-right">
                  <span class="font-15">Cantidad:</span>
                </div>
                <div class="col-lg-5 col-6 text-right">
                <input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputQtyToAddStock" id="inputQtyToAddStock" min="1" v-model="qtyToAddStock" v-on:keypress="NumbersOnly">
                </div>
              </div>
            </div>
						<template #modal-footer>
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelAddStock">
							Cancelar
						</b-button>
						<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.stop="confirmAddStock">
							Agregar
						</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para agregar gasto -->
				<div>
					<b-modal ref="modal-register-expense" 
						:hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
            <h2 class="text-center">Registrar gasto</h2>
						<hr class="my-3">
						<div>
              <b-form-textarea
                v-model="expenseConceptToRegister"
                placeholder="Ingresa el concepto del gasto ..."
                no-resize
              ></b-form-textarea>
						</div>
            <div>
              <div class="row align-items-center mt-2">
                <div class="col-lg-7 col-6 text-right">
                  <span class="font-15">Monto:</span>
                </div>
                <div class="col-lg-5 col-6 text-right">
                <input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputExpenseAmount" id="inputExpenseAmount" min="1" v-model="expenseAmountToRegister" v-on:keypress="NumbersOnly">
                </div>
              </div>
            </div>
						<template #modal-footer>
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelAddExpense">
							Cancelar
						</b-button>
						<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.stop="confirmAddExpense">
							Registrar
						</b-button>
						</template>
					</b-modal>
				</div>

      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import formatHelper from "@mixins/formatHelper"
import NavClock from "@components/pos/NavClock"
import notificationsHelper from "@mixins/notificationsHelper"
export default {
  name: "PosNavbar",
  props: {
    name: {
      type: String,
      default: "",
    },
    location: {
      type: String,
      default: "",
    },
  },
  components: {
    NavClock
  },
  mixins: [formatHelper, notificationsHelper],
  data() {
    return {
      logoBrink: require("@assets/images/misc/logo-brink.png"),
      // Caja chica
      cashOutInfo: [],
      cashOutInfoFields: [{ key: 'qty', label: 'Cantidad', thStyle: 'font-size: small' }, 
                          { key: 'product_name', label: 'Producto', thStyle: 'font-size: small'},
                          { key: 'total', label: 'Monto', thStyle: 'font-size: small'}],
      expensesInfo: [],
      expensesOutInfoFields: [{ key: 'expense_concept', label: 'Gasto', thStyle: 'font-size: small'}, { key: 'expense_amount', label: 'Monto',thStyle: 'font-size: small'}],
      incidentsInfo: [],
      incidentsInfoFields: [{ key: 'incident_comment', label: 'Incidente', thStyle: 'font-size: small'}, { key: 'incident_amount_refunded', label: 'Monto',thStyle: 'font-size: small'}],
      amountCashOutCalculated: 0,
      amountPettyCash: 0,
      amountCardPayments: 0,
      totalCardPayments: 0,
      totalMovesCashOut: 0,
      totalMovesExpenses: 0,
      totalMovesIncidents: 0,
      amountTotalEfectivo: 0,
      amountExist: 0,
      cashOutDiff: 0,
      // Agregar inventario
      productToAddStockSelected: 1,
      productsToAddStock: [],
      productToAddStockName: null,
      qtyToAddStock: 1,
      // Registrar gasto
      expenseConceptToRegister: '',
      expenseAmountToRegister: 1,

    }
  },
  watch: {
	amountExist(n,o){
		this.updateCashOutDiff()
  }
  },
  async mounted(){
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("general", ["user_subsidiary"]),
    ...mapGetters("general", ["getProductsSubsidiary"])
  },
  methods: {
    ...mapState("general", ["user_subsidiary"]),
    ...mapGetters("general", ["getProductsSubsidiary"]),
    async logout() {
      this.$emit("on-logout");
    },
    onRefreshPos() {
      location.reload()
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async openPettyCash(){
      await this.getCashOutInfo()
      await this.getExpensesInfo()
      await this.getIncidentsInfo()
      await this.getCardPayments()
      this.updateAmountsCashOut()
      this.pettyCashRefresh()
      this.$refs['modal-petty-cash'].show();
    },
    async pettyCashRefresh(){
      await this.getCashOutInfo()
      await this.getExpensesInfo()
      await this.getIncidentsInfo()
      await this.getCardPayments()
      this.updateAmountsCashOut()
    },
    async getCashOutInfo(){
      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      const res = await this.xget('/api/cash_out_info_subsidiary/'+sub_id+'/user/'+this.user.id);
      if(res.success){
        this.setCashOutInfo(res.data);
      }
    },
    setCashOutInfo(cashOutData){
      this.cashOutInfo = []
      var totalmoves = 0
      cashOutData.forEach(data => {
        var cash_out_move = {
          qty: parseInt(data.qty),
          product_id: data.product_id,
          product_name: data.product_name,
          total: this.fixedFormat(data.total, 2)
        };
        this.cashOutInfo.push(cash_out_move);
        totalmoves = totalmoves + parseFloat(data.total)
      });
      this.totalMovesCashOut = totalmoves
    },
    async getExpensesInfo(){
      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      const res = await this.xget('/api/expenses_info_subsidiary/'+sub_id+'/user/'+this.user.id);
      if(res.success){
        this.setExpensesInfo(res.data);
      }
    },
    setExpensesInfo(expensesData){
      this.expensesInfo = []
      var totalmoves = 0
      expensesData.forEach(data => {
        var expense_move = {
          expense_concept: data.expense_concept,
          expense_amount: this.fixedFormat(data.expense_amount, 2)
        };
        this.expensesInfo.push(expense_move);
        totalmoves = totalmoves + parseFloat(data.expense_amount)
      });
      this.totalMovesExpenses = totalmoves
    },
    async getIncidentsInfo(){
      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      const res = await this.xget('/api/incidents_info_subsidiary/'+sub_id+'/user/'+this.user.id);
      if(res.success){
        this.setIncidentsInfo(res.data);
      }
    },
    setIncidentsInfo(incidentsData){
      this.incidentsInfo = []
      var totalmoves = 0
      incidentsData.forEach(data => {
        var incident_move = {
          incident_comment: data.incident_comment,
          incident_amount_refunded: this.fixedFormat(data.incident_amount_refunded, 2)
        };
        this.incidentsInfo.push(incident_move);
        totalmoves = totalmoves + parseFloat(data.incident_amount_refunded)
      });
      this.totalMovesIncidents = totalmoves
    },
    async getCardPayments(){
      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      const res = await this.xget('/api/card_payments_info_subsidiary/'+sub_id+'/user/'+this.user.id);
      if(res.success){
        // VENTA CON TARJETA
        this.amountCardPayments = this.fixedFormat(res.data,2)
        this.totalCardPayments = parseFloat(res.data)
      }else{
        this.amountCardPayments = this.fixedFormat(0,2)
      }
    },
    updateAmountsCashOut(){
      // CAJA CHICA
      this.amountPettyCash = parseFloat(this.user_subsidiary.subsidiary_petty_cash)
      // VENTA TOTAL DEL DÍA
      let amountSalesPettyCash = this.totalMovesCashOut
      this.amountCashOutCalculated = parseFloat(amountSalesPettyCash)
      // TOTAL EN EFECTIVO
      // Venta del día menos VENTA CON TARJETA, GASTOS E INCIDENCIAS
      let amountExpensesIncidents = this.totalMovesExpenses + this.totalMovesIncidents
      let amountCardPaymentsExpensesIncidents = parseFloat(this.totalCardPayments) + parseFloat(amountExpensesIncidents)
      this.amountTotalEfectivo = amountSalesPettyCash - amountCardPaymentsExpensesIncidents
    },
    updateCashOutDiff(){
      // Se valida valor existente vacío
      if(this.amountExist === ''){
        this.cashOutDiff = this.fixedFormat(0, 2)
      }else{
        // Se calcula diferencia en caja chica
        let amountSalesPettyCash = this.totalMovesCashOut + parseFloat(this.user_subsidiary.subsidiary_petty_cash)
        let amountExpensesIncidents = this.totalMovesExpenses + this.totalMovesIncidents
        let diff_cash = parseFloat(this.amountExist) - (amountSalesPettyCash - amountExpensesIncidents)
        this.cashOutDiff = this.fixedFormat(diff_cash, 2)
      }        
    },
    async cashOutRegister() {
      if(!this.amountPettyCash || this.amountPettyCash <= 0){
        this.warningNotif('ATENCIÓN:', '¡Ingresa un Monto de "Caja Chica" válido!')
      }else{
        await this.registerCashOut(this.amountCashOutCalculated, this.amountTotalEfectivo, this.totalCardPayments);
        this.$refs['modal-petty-cash'].hide();
      }
    },
    async registerCashOut(amountCashOutCalculated, amountExist, cashOutDiff){

      //this.showLoader("Guardando información de corte de caja ...")

      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      
      const info = {
        amount_calculated: amountCashOutCalculated,
        amount_reported: amountExist,
        amount_difference: cashOutDiff,
        user_id: this.user.id,
        subsidiary_id: sub_id
      }

      const data = {
        Cash_Out: info
      }

      const res = await this.xpost("/api/register_cash_out_info", data);

      if(res.success){
        this.successNotif("CORTE DE CAJA:", '¡Registrado Exitosamente!')
      }
      else {
        this.errorNotifDialog("Ha ocurrido un error al registrar corte de caja.", res.error)
      }

      //this.stopLoader()

    },
    cashOutCancel(){
      this.$refs['modal-petty-cash'].hide();
    },
    openAddStock(){
      // Se filtran productos en los que se puede adicionar stock
      let productsSubsidiary = this.getProductsSubsidiary
      this.productsToAddStock = productsSubsidiary.filter(f => (f.product_type === 'CALCETAS' || f.product_type === 'DULCERIA' || 
                                                          f.product_type === 'ARTICULO COVID' || f.product_type === 'OTROS'))
      // Se escoge primer producto del listado
      if(this.productsToAddStock.length > 0){
        this.productToAddStockSelected = this.productsToAddStock[0].product_id
        this.productToAddStockName = this.productsToAddStock[0].product_name
      }
      // Se inicializa cantidad en 1
      this.qtyToAddStock = 1
      this.$refs['modal-add-stock'].show();
    },
    onChangeProductToAddStock: function(event) {
		  this.productToAddStockName = this.productsToAddStock.find(f => f.product_id === this.productToAddStockSelected).product_name;
    },
    async confirmAddStock(){
      if(!this.qtyToAddStock || this.qtyToAddStock <= 0){
        this.warningNotif('ATENCIÓN:', '¡Ingresa una cantidad válida!')
      }else{
        await this.registerAddStock(this.productToAddStockSelected, this.qtyToAddStock);
        this.$refs['modal-add-stock'].hide();
      }
    },
    async registerAddStock(product_id, product_qty){

      //this.showLoader("Guardando información de inventario ...")

      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      
      const info = {
        subsidiary_id: sub_id,
        product_id: product_id,
        quantity: product_qty,
        // Movement_type (2) EN_SUCURSAL
        movement_type_id: 2,
        user_id: this.user.id
      }

      const data = {
        Move_Stock: info
      }

      const res = await this.xpost("/api/register_stock_moves", data);

      if(res.success){
        this.successNotif("INVENTARIO: ", '¡Registrado exitosamente!')
      }
      else {
        this.errorNotifDialog("Ha ocurrido un error al registrar inventario.", res.error)
      }

      //this.stopLoader()

    },
    cancelAddStock(){
      this.$refs['modal-add-stock'].hide();
    },
    openRegisterExpense(){
      this.expenseConceptToRegister = ''
      this.expenseAmountToRegister = 1
      this.$refs['modal-register-expense'].show();
    },
    async confirmAddExpense(){
      if(!this.expenseAmountToRegister || this.expenseAmountToRegister <= 0){
        this.warningNotif('ATENCIÓN:', '¡Ingresa un monto válido!')
      }else if(this.expenseConceptToRegister === ''){
        this.warningNotif('ATENCIÓN:', '¡Ingresa un concepto válido!')
      }else{
        this.registerExpense(this.expenseConceptToRegister, this.expenseAmountToRegister);
        this.$refs['modal-register-expense'].hide();
      }
    },
    async registerExpense(expense_concept, expense_amount){

      //this.showLoader("Guardando información de gasto ...")

      // Se valida el rol de usuario y la sucursal
      var sub_id = null
      var role = this.user.meta_type;
      if(role === "Admin"){
        sub_id = this.user_subsidiary.subsidiary_id
      }else{
        sub_id = this.user.meta_info.subsidiary_id
      }
      
      const info = {
        concept: expense_concept,
        expense_total: expense_amount,
        user_id: this.user.id,
        subsidiary_id: sub_id
      }

      const data = {
        Expense: info
      }

      const res = await this.xpost("/api/register_expense_info", data);

      if(res.success){
        this.successNotif("GASTO: ", "¡Registrado exitosamente!")
      }
      else {
        this.errorNotifDialog("Ha ocurrido un error al registrar gasto.", res.error)
      }

      //this.stopLoader()

    },
    cancelAddExpense(){
      this.$refs['modal-register-expense'].hide();
    }
  },
};
</script>
